// @flow

import IframeChallenge from './IframeChallenge';
import isSamsungBuiltinBrowser from '../../../lib/isSamsungBuiltinBrowser';


class OoyalaChallenge extends IframeChallenge {
    static disablesSupportButton() {
        return true;
    }

    static isSupportedOnCurrentPlatform() {
        return !isSamsungBuiltinBrowser();
    }

    static shouldShowSkipButtonOnStart() {
        return false;
    }

    iFrameSource() {
        const challenge = this.props.challenge;
        const placement = challenge && (challenge.placement || challenge.OY_CONTENTID);
        if (typeof placement !== 'string') return null;
        return `/ooyala.html?content_id=${encodeURIComponent(placement)}`;
    }

    eventImpression() {
        super.eventImpression();
        // this.trackImpression(() => {});
        // this.trackAdOpportunity(true);
    }

    eventPassback() {
        super.eventPassback();
        // this.trackAdOpportunity(false);
    }
}

export default OoyalaChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/OoyalaChallenge.jsx